export default __webpack_public_path__ + "static/media/Blog-posts.d65b9bfb.svg";